<div class="tootlp-container">
    <ng-content></ng-content>
    <div class="tooltip-wrap" [class]="position">
        <div class="text-white text-center whitespace-nowrap">{{tooltip}}</div>
        <div class="mt-1 flex gap-2" *ngIf="controls.length > 0">
            <div class="py-1 px-[10px] rounded-md leading-4 text-white bg-[#1e1d1e]" *ngFor="let control of controls">{{control}}
            </div>
        </div>
    </div>
</div>